import { Textarea } from "@chakra-ui/react";
import { forwardRef } from "react";
import {
  Controller,
  FieldErrors,
  FieldValues,
  useFormContext,
} from "react-hook-form";

import { Field } from "../ui/field.tsx";
import { InputGroup } from "../ui/input-group.tsx";

export type ControlledTextAreaProps = {
  label?: string;
  placeholder?: string;
  name: string;
  className?: string;
  id?: string;
  errors?: FieldErrors<FieldValues>;
  disabled?: boolean;
  icon?: string;
  defaultValue?: string;
  size?: "xs" | "sm" | "md" | "lg";
};

const ControlledTextArea = forwardRef<
  HTMLInputElement,
  ControlledTextAreaProps
>(
  ({
    placeholder,
    name = "",
    disabled = false,
    id,
    defaultValue = "",
    size = "sm",
    label,
    className,
  }) => {
    const { control } = useFormContext();

    return (
      <Controller
        control={control}
        defaultValue={defaultValue}
        name={name}
        render={({ field, fieldState: { error } }) => (
          <InputGroup className={className}>
            <Field
              invalid={!!error?.message}
              label={label}
              errorText={error?.message}
              color={"#000000"}
            >
              <Textarea
                placeholder={placeholder}
                id={id}
                className={className}
                value={field.value ?? ""}
                onChange={field.onChange}
                disabled={disabled}
                variant={"outline"}
                size={size}
                borderWidth={"1px"}
                borderColor={"#d3d3d3"}
                fontSize={"14px"}
                borderRadius={"0.5rem"}
                paddingLeft={"0.5rem"}
                paddingTop={"0.5rem"}
              />
            </Field>
          </InputGroup>
        )}
      />
    );
  },
);

ControlledTextArea.displayName = "ControlledTextArea";

export default ControlledTextArea;
